import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay, tap} from 'rxjs/operators';

const CACHE_TTL = 5000;
/**
 * Prevents the same endpoint for being
 * hit more then once while there are
 * outstanding requests. i.e. when
 * multiple components on the page
 * request a building summary.
 */
@Injectable({
  providedIn: 'root'
})
export class CachedApiClientService {

  private readonly cache = new Map<string, Observable<any>>();

  constructor(
    private http: HttpClient,
  ) {}

  public get<ResponseType>(endpoint: string): Observable<ResponseType> {
    const cacheKey = `GET@${endpoint}`;
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }
    return this.retain(cacheKey, this.http.get<ResponseType>(endpoint));
  }

  private retain<ResponseType>(cacheKey: string, request: Observable<ResponseType>) {
    const cachedRequest = request.pipe(
      tap(() => setTimeout(() => this.cache.delete(cacheKey), CACHE_TTL)),
      shareReplay(1),
    );
    this.cache.set(cacheKey, cachedRequest);
    return cachedRequest;
  }
}
